
import httpApi from '@/apis/http.api'

export default function(app) {
  app.config.globalProperties.$axios = httpApi
}
